import striptags from "striptags";

export default function prepDescr(descr?: string) {
	if (!descr) return undefined;
	let newDescr = descr;
	newDescr = striptags(newDescr);
	const dotPlace = newDescr.indexOf(".", 130);
	return striptags(descr).slice(0, dotPlace);
}
